<template>
    <div class="sidebar">
      <div>
        <div class="sidebar-top">
          <h1>Fantasyroom</h1>
          <span>Reklamationsverwaltung</span>
          <span class="creditstext">
            Credits to <br />
            <a href="http://devgosling.tech/">Steven Kukla</a> <br /> & <br />
            <a href="http://your-infra.de/">Lee Daniel Hertel</a>
          </span>
        </div>
  
        <br />
  
        <div class="sidebar-div sidebar-middlepart">
          <div class="sidebar-div fadein d500ms">
            <br>
            <RouterLink class="sidebar-button" to="#">
          <Button
            @click="logout"
            label="Abmelden"
            icon="fa-solid fa-right-to-bracket"
            severity="secondary"
            style="text-align: left; width: 100%;"
            text
            outlined
          />
        </RouterLink>
            <span class="sidebar-category">HAUPTBEREICH</span>
            <div class="sidebar-button-container">
              <RouterLink class="sidebar-button" to="/">
                <Button
                  label="Startseite"
                  icon="fa-solid fa-house"
                  severity="primary"
                  style="text-align: left; width: 100%;"
                  text
                  :outlined="currentRoute.name === 'home'"
                />
              </RouterLink>
            </div>
          </div>
  
          <div class="sidebar-div" v-for="(category, i) in sidebarData" :key="i">
            <span class="sidebar-category fadein" :class="'d' + (i + 1) * 100 + 'ms'">
              {{ category.name }}
            </span>
            <div class="sidebar-button-container fadein" :class="'d' + (i + 1) * 100 + 'ms'">
              <template v-for="(btn, e) in category.buttons" :key="e">
                <RouterLink
                  v-if="btn && btn.site"
                  class="sidebar-button fadein"
                  :to="'/' + btn.site"
                >
                  <Button
                    :label="btn.label"
                    :icon="btn.icon"
                    severity="primary"
                    style="text-align: left; width: 100%;"
                    text
                    :outlined="currentRoute.name && currentRoute.name.startsWith(btn.site)"
                    :disabled="btn.disabled"
                  />
                </RouterLink>
              </template>
            </div>
          </div>
        </div>
      </div>
  
      <div class="sidebar-bottom">
      </div>
    </div>
  </template>
  
  <script>
  import router from '../router/index.js';
  import Button from 'primevue/button';
  import { useRoute, RouterLink } from 'vue-router';
  import { getAuth, onAuthStateChanged } from 'firebase/auth';
  import axios from 'axios';
  import { config } from '../assets/config.js';
  import Tag from 'primevue/tag';
  
  export default {
    components: {
      Button,
      RouterLink,
      Tag,
    },
    data() {
      return {
        sidebarData: [],
      };
    },
    computed: {
      currentRoute() {
        return this.$route;
      },
    },
    methods: {
      async logout() {
        await getAuth().signOut();
        this.$router.push('/login');
        location.reload();

      },
      async loadSidebarData(user) {
        try {
          const token = await user.getIdToken();
          const response = await axios.get(config.api_url + '/api/sidebar/access', {
            headers: {
              Authorization: token,
            },
          });
  
          this.sidebarData = response.data.map((category) => ({
            ...category,
            buttons: (category.buttons || []).filter((btn) => btn && btn.site),
          }));
  
        } catch (error) {
          console.error('Error loading sidebar data:', error);
        }
      },
    },
    mounted() {
      const auth = getAuth();
  
      onAuthStateChanged(auth, async (user) => {
        if (!user) {
          console.warn('No user logged in. Redirecting to login.');
          this.$router.push('/login');
          return;
        }
  
        await this.loadSidebarData(user);
      });
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .sidebar {
    width: 17.5rem;
    min-height: 100vh;
    background-color: var(--surface-overlay);
    padding: 0.5rem;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  
    transform: translateX(-100%);
    animation-delay: 100ms;
    animation-name: init;
    animation-duration: 800ms;
    animation-fill-mode: forwards;
    animation-timing-function: ease;
  
    overflow-x: hidden;
    overflow-y: auto;
  
    &::-webkit-scrollbar {
      width: 3px;
    }
  
    &-div {
      width: 100%;
    }
  
    &-top {
  padding-top: 2rem;
  padding-bottom: 1rem;
  text-align: center;

  height: 9.5rem;

  span {
    transform: translateY(-1rem);
  }
}

  
    &-bottom {
      width: 100%;
      display: flex;
      justify-content: center;
      margin-top: 1rem;
    }
  
    div {
      display: flex;
      flex-direction: column;
      align-items: center;
  
      img {
        width: 75%;
      }
    }
  
    &-button-container {
      width: 100%;
      margin-top: 0.2rem;
    }
  
    &-button {
      width: 90%;
      margin-top: 0.2rem;
    }
  
    &-category {
      width: 90%;
      font-weight: 600;
      font-size: 0.75rem;
      color: var(--surface-400);
      text-indent: 1rem;
      margin-top: 1rem;
    }
  }
  
  .creditstext {
    font-size: 0.675rem;
  }
  
  @keyframes init {
    from {
      transform: translateX(-100%);
    }
    to {
      transform: translateX(0%);
    }
  }
  </style>
  